export default "__VITE_ASSET__CrYWXfE9__"